// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-endpoint-network-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-endpoint-network-protection',
  title:
    'Implement endpoint network protection: firewall, Always On VPN and host-based intrusion detection',
  description:
    "Endpoint devices used to deliver services must be protected against untrusted networks via: a maintained host firewall; security event logging; Always On VPN ensuring all traffic is routed through the organisation's secure gateway; and host-based intrusion detection system (HIDS) software.",
  category: 'technical',
  scfIds: ['SCF-NET-003', 'SCF-NET-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Endpoint network protection standard is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
